export default "__VITE_ASSET__CXqCGWUZ__"